module.exports = __webpack_public_path__ + "media/images/countryrect/tibet-69b42c1fc1d87b6f8933db5e116274f6.svg";